import React, { useState } from 'react';
import BasePracticeMode from '../../common/practice/BasePracticeMode';
import AlgorithmSelector from '../../common/algorithm/AlgorithmSelector';
import { getRandomCase, getAlgorithmSet } from '../../../constants/algorithms';
import { PRACTICE_MODES } from '../../../constants/modes';
import { useLocation } from 'react-router-dom';
import SlowestAlgorithmsPanel from '../../statistics/panels/SlowestAlgorithmsPanel';
import { logDebug } from '../../../utils/logging';

export default function OLLRecognitionExecution() {
  const ollSet = getAlgorithmSet('OLL');
  const location = useLocation();

  const [selectedAlgorithms, setSelectedAlgorithms] = useState(() => {
    if (location.state?.selectedAlgorithms) {
      return location.state.selectedAlgorithms;
    }
    return Object.keys(ollSet.cases);
  });

  const [currentCase, setCurrentCase] = useState(() => {
    return getRandomCase('OLL', PRACTICE_MODES.OLL.RECOGNITION, selectedAlgorithms);
  });
  const [showSolution, setShowSolution] = useState(false);

  const handleComplete = (time) => {
    logDebug('Recognition completed:', {
      algorithm: currentCase.id,
      time,
      mode: PRACTICE_MODES.OLL.RECOGNITION
    });

    const nextCase = getRandomCase('OLL', PRACTICE_MODES.OLL.RECOGNITION, selectedAlgorithms);
    if (nextCase) {
      setCurrentCase(nextCase);
      setShowSolution(false);
    }
  };

  const handleAlgorithmSelection = (selected) => {
    setSelectedAlgorithms(selected);
    const nextCase = getRandomCase('OLL', PRACTICE_MODES.OLL.RECOGNITION, selected);
    if (nextCase) {
      setCurrentCase(nextCase);
      setShowSolution(false);
    }
  };

  const handleSkipCase = () => {
    setCurrentCase(getRandomCase('OLL', PRACTICE_MODES.OLL.RECOGNITION, selectedAlgorithms));
    setShowSolution(false);
  };

  const handleRedoCase = () => {
    setShowSolution(false);
  };

  const renderContent = () => (
    <div className="algorithm-display">
      <AlgorithmSelector
        algorithms={ollSet}
        selectedAlgorithms={selectedAlgorithms}
        onChange={handleAlgorithmSelection}
        type="OLL"
      />
      
      <div className="setup-moves">
        <h3>Setup Moves:</h3>
        <p className="algorithm-text">{currentCase.setupAlgorithm}</p>
        {currentCase.displayName && (
          <p className="insert-type">({currentCase.displayName})</p>
        )}
      </div>
      {showSolution && (
        <>
          <h2>{currentCase.name}</h2>
          <div className="solution-moves">
            <h3>Solution:</h3>
            <p className="algorithm-text">{currentCase.algorithm}</p>
          </div>
        </>
      )}
    </div>
  );

  return (
    <>
      <BasePracticeMode
        mode={PRACTICE_MODES.OLL.RECOGNITION}
        title="OLL Recognition Practice"
        algorithmId={currentCase.id}
        isRecognitionMode={true}
        onComplete={handleComplete}
        onSkipCase={handleSkipCase}
        onRedoCase={handleRedoCase}
        renderContent={renderContent}
        showSolution={showSolution}
        onToggleSolution={() => setShowSolution(!showSolution)}
      />
      <SlowestAlgorithmsPanel 
        mode={PRACTICE_MODES.OLL.RECOGNITION}
        title="Slowest OLL Recognition"
      />
    </>
  );
} 